import { SearchResult } from '#server/models';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  Badge,
} from '@/components';
import { cn } from '@/utils';

export interface ResearchResultCardProps {
  result: SearchResult;
}

export const ResearchResultCard = ({ result }: ResearchResultCardProps) => {
  const researchDetails = result.researchDetails!;

  return (
    <ResultCardLink to={researchDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <ResultCardHeader>
          <ResultCardTag>
            {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
            <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>Research</Badge>
          </ResultCardTag>
          <ResultCardTitle>{researchDetails.title}</ResultCardTitle>
          <ResultCardDescription>{researchDetails.description}</ResultCardDescription>
        </ResultCardHeader>
      </ResultCard>
    </ResultCardLink>
  );
};
